import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import TEST_ID from "enums/TEST_ID";
import ActionButton from "components/Buttons/ActionButton";
import { getDataTestProp } from "utils/cypressTesting";

interface MfaChallengeProps {
  code: string;
  rememberDevice: boolean;
  isWriting: boolean;
  onCodeChange: (code: string) => void;
  onRememberDeviceChange: (checked: boolean) => void;
  onSubmit: () => void;
  onResend: () => void;
}

export default function MfaChallenge({
  code,
  rememberDevice,
  isWriting,
  onCodeChange,
  onRememberDeviceChange,
  onSubmit,
  onResend,
}: MfaChallengeProps) {
  const isValidCode = code.length === 6 && /^\d{6}$/.test(code);

  return (
    <Grid container direction="column" spacing={1}>
      <Grid size={{ xs: 12 }} sx={{ mb: 2, mt: 2 }}>
        <TextField
          label="Verification code"
          type="text"
          inputMode="numeric"
          fullWidth
          required
          value={code}
          onChange={(e) => onCodeChange(e.target.value.replace(/\D/g, ""))}
          slotProps={{
            htmlInput: {
              maxLength: 6,
              ...getDataTestProp(TEST_ID.login.mfaCodeInput),
            },
          }}
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <ActionButton
          fullWidth
          onClick={onSubmit}
          disabled={!isValidCode || isWriting}
          data-testid={TEST_ID.login.mfaSubmit}
          {...getDataTestProp(TEST_ID.login.mfaSubmit)}
        >
          Verify
        </ActionButton>
      </Grid>

      <Grid size={{ xs: 12 }}>
        <ActionButton
          fullWidth
          onClick={onResend}
          disabled={isWriting}
          {...getDataTestProp(TEST_ID.login.mfaResend)}
        >
          Resend code
        </ActionButton>
      </Grid>

      <Grid size={{ xs: 12 }}>
        <label
          style={{
            display: "flex",
            alignItems: "center",
            gap: 8,
            cursor: "pointer",
          }}
        >
          <input
            type="checkbox"
            checked={rememberDevice}
            onChange={(e) => onRememberDeviceChange(e.target.checked)}
            data-testid={TEST_ID.login.mfaRememberDevice}
            {...getDataTestProp(TEST_ID.login.mfaRememberDevice)}
          />
          Remember this device for 30 days
        </label>
      </Grid>
    </Grid>
  );
}
